/* -------------------------------------------------------------------------- */
/*                         Schema Imported Locations                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const importedLocation = new schema.Entity('importedLocations', {}, { idAttribute: 'id' });
export const importedLocations = new schema.Array(importedLocation);
